import React, { Suspense } from "react";
const LazyLine = React.lazy(() =>
  import("react-chartjs-2").then((mod) => ({ default: mod.Line }))
);
const MarketInsightCard = () => {
  const priceData = {
    labels: ["Jun", "Feb", "Mar", "Apr", "May", "Jun"],
    datasets: [
      {
        data: [30, 38, 35, 40, 45, 48],
        borderColor: "#735DFF",
        backgroundColor: "rgba(115, 93, 255, 0.1)",
        tension: 0.4,
        fill: true,
        pointRadius: 0,
        borderWidth: 2,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: "#000750",
        padding: 12,
        borderRadius: 8,
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { font: { size: 10 } },
      },
      y: {
        grid: { color: "#f3f4f6" },
        ticks: { font: { size: 10 } },
      },
    },
  };

  return (
    <div className="bg-white rounded-lg shadow-sm p-4">
      <h3 className="font-bold text-text-primary mb-4 text-lg">
        Market Insights
      </h3>

      <div className="mb-6">
        <p className="text-sm text-text-secondary mb-2">Avg price trends</p>
        <p className="text-xs text-text-muted mb-3">₹36.00 (₹ +8 L)</p>

        <div className="h-32">
          <Suspense fallback={<div className="h-32" />}>
            <LazyLine data={priceData} options={chartOptions} />
          </Suspense>
        </div>
      </div>

      <div>
        <h4 className="font-semibold text-text-primary mb-2">
          Market Consumption
        </h4>

        <div className="flex items-start justify-between bg-blue-50 rounded-lg p-3 mb-2">
          <div>
            <p className="font-semibold text-text-primary text-sm">
              Basic Agent
            </p>
            <p className="text-xs text-text-secondary">
              Plan expires on <br /> Oct 12, 2024
            </p>
          </div>

          <button className="mt-2 bg-primary text-white px-4 py-2 rounded-lg text-xs font-medium hover:bg-opacity-90 whitespace-nowrap">
            Upgrade Plan
          </button>
        </div>
      </div>
    </div>
  );
};

export default MarketInsightCard